<template>
    <n-loading-bar-provider>
        <n-dialog-provider>
            <n-notification-provider>
                <n-message-provider>
                    <router-view :key="$route.fullPath" />
                </n-message-provider>
            </n-notification-provider>
        </n-dialog-provider>
    </n-loading-bar-provider>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useMessage } from 'naive-ui';
import type { MessageApiInjection } from 'naive-ui/lib/message/src/MessageProvider';
export default defineComponent({
    name: 'AppApplication',
    setup() {
        (globalThis as unknown as { $message: MessageApiInjection }).$message = useMessage();
    },
});
</script>
